import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Approdo',
    description: 'Le aziende B2B e gli annunci di lavoro in linea con il tuo profilo, ogni giorno in un solo posto.',
    url: getOrigin()
}
